import {useEffect, useState} from 'react';
import {DEFAULT_COLUMNS} from '../utils/assets';
import _ from 'lodash';
import {useGetAlertParametersTypeQuery} from '../redux/api/alertParameters';

export default function useAssetsColumns(): {
  columns: string[],
  addColumns: (columns: string | string[]) => void,
  removeColumns: (columns: string | string[]) => void,
  resetColumns: () => void,
} {
  
  const {data: alertParametersTypeSources} = useGetAlertParametersTypeQuery({paginate: false})
  
  const [columns, setColumns] = useState([...DEFAULT_COLUMNS, "total_uog_contacts", "event_cluster"]);
  
  useEffect(()=> {
    setColumns(prevState => [...prevState, ...(alertParametersTypeSources ?? []).map(el => el.code)])
  }, [alertParametersTypeSources])
  
  function addColumns(addColumns: string | string[]) {
    const addColumnsArray = Array.isArray(addColumns) ? addColumns : [addColumns];
    
    setColumns([...columns, ...addColumnsArray]);
  }
  
  function removeColumns(removeColumns: string | string[]) {
    const removeColumnsArray = Array.isArray(removeColumns) ? removeColumns : [removeColumns];
    
    setColumns(_.difference(columns, removeColumnsArray));
  }
  
  function resetColumns() {
    setColumns(DEFAULT_COLUMNS);
  }
  
  return {
    columns,
    addColumns,
    removeColumns,
    resetColumns
  };
}